import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS, FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../../antrag-components/PruefAssistenz';
import ApplicationHeading from '../../../../../../application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

const AusgangssituationAntragEmobInvest: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Ausgangssituation' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109726323_tuation_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0250110818_nweis_Fuer_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0180972573_on_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0243997268_ssituation_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm
				formStruc={AusgangssituationFormStruc()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={updatedReadOnly}
			/>
		</>
	);
};

export default AusgangssituationAntragEmobInvest;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0243997268_ssituation_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const AusgangssituationFormStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0066822094_Unternehmens_Der_Institution,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0250963699_ktueller_Stand_Des_Fuhrparks,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0033937044_ion_In_Die_Elektromobilitaet,
				P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0015690343_t_Der_Staatlichen_Foerderung,
				{
					...P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0095548994_est_Ausgangssituation_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...EMOB_INVEST_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAusgangssituationAntragEmobInvest = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0109726323_tuation_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_Invest.schema.attributes.Projektbeschreibung_Elek_0243997268_ssituation_Pruefung_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), AusgangssituationFormStruc());
	else return concat(AusgangssituationFormStruc());
};
